import { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { LinearProgress, RadioGroup } from "@mui/material";
import CustomRadioButton from "components/RadioButton";
import { DateRangePicker } from "components/DateRangePicker";
import { Container } from "./styles";

type DateRange = [Dayjs | null, Dayjs | null];

interface IDriverPeriodFilterProps {
  startDate: string;
  endDate: string;
  onChange: (startDate: string, endDate: string) => void;
  disabled?: boolean;
}

const today = new Date();
const formatDate = (date: Date) => dayjs(date).format("YYYY-MM-DD");
const TODAY = formatDate(today);
const daysAgo = (days: number) => formatDate(new Date(today.getFullYear(), today.getMonth(), today.getDate() - days));

const PRESETS = [
  { label: "Hoje", value: TODAY },
  { label: "Últimos 7 dias", value: daysAgo(7) },
  { label: "Últimos 15 dias", value: daysAgo(15) },
  { label: "Últimos 30 dias", value: daysAgo(30) },
  { label: "Período customizado", value: "custom" },
];

export function DriverPeriodFilter({ startDate, endDate, onChange, disabled }: IDriverPeriodFilterProps) {
  const getSelectedPreset = () => {
    if (endDate !== TODAY) return "custom";
    const match = PRESETS.find((preset) => preset.value === startDate);
    return match ? match.value : "custom";
  };

  const [selected, setSelected] = useState<string>(getSelectedPreset());
  const [customRange, setCustomRange] = useState<DateRange>([null, null]);

  const handlePresetChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelected(value);

    if (value !== "custom") {
      onChange(value, TODAY);
    }
  };

  const handleCustomRangeChange = (range: DateRange) => {
    setCustomRange(range);

    if (range[0] && range[1]) {
      onChange(range[0].format("YYYY-MM-DD"), range[1].format("YYYY-MM-DD"));
    }
  };

  return (
    <Container>
      <RadioGroup value={selected} onChange={handlePresetChange}>
        {PRESETS.map((preset) => (
          <CustomRadioButton
            key={preset.value}
            text={preset.label}
            value={preset.value}
            checked={selected === preset.value}
            handleChange={handlePresetChange}
            disabled={disabled}
            size="small"
            align="flex-start"
            compact
          />
        ))}
      </RadioGroup>

      {disabled && <LinearProgress aria-label="Atualizando periodo" />} 

      {selected === "custom" && (
        <DateRangePicker
          value={customRange}
          onChange={handleCustomRangeChange}
          label="Selecione o período"
          disabled={disabled}
        />
      )}
    </Container>
  );
}

export default DriverPeriodFilter;
